import React from 'react'
import TextEditor from '../components/TextEditor/TextEditor'
import Pattern from '../components/Pattern/Pattern'

const doc = {
  title: 'What is a .PAT file?',
  slug: 'what-is-a-pat-file',
  tags: ['education'],
  category: 'pat-file-basics',
  content: (props) => {
      return <div>
      <h5>A few small but mighty lines of text</h5>
      <p className="p-push-down">
        Each hatch pattern is a stored in a .PAT file as a collection of rules describing the angle and spacing of infinitely repeating lines in order to represent a particular material or meaning. 
        There are specific rules a PAT file must follow - in addition to unique syntax requirements to ensure compliance with the major AutoCAD and Revit programs. 
        PAT files can be opened with any text editor, but are intended to be imported and used within architecture software.
      </p>

      <div className="row doc-row row-push-down-extra">
        <div className="col-md-6">
          <p className="">a .PAT file that looks like this...</p>
          <div className="col-themed col-themed-no-pad theme-dark" style={{height: 250}}>
            <TextEditor demo={true} cacheID={'features_text'}/>
            <div className="banner banner-yellow">Edit me!</div>
          </div>
        </div>

        <div className="col-md-6">
          <p className="">...tells your architecture software to display this:</p>
          <div className="col-themed col-themed-no-pad" style={{height: 250}}>
            <Pattern colors={false} gui={false} pattern={props.patternManager.cache['features_text']}/>
          </div>
        </div>
      </div>

      <div className="doc-callout doc-callout-warning">
        <span className="doc-callout-type-label"><i className="fas fa-exclamation-circle"/> IMPORTANT NOTE</span>
        <strong>Other industries also use the .PAT file extension, but for different purposes</strong>
        <p className="">
          Another file type that uses the .PAT extension is an image file used for pattern work in graphical editing programs such as Photoshop, GIMP, Corel, and more. These are not compatible with Pattycake or CAD software like AutoCAD and Revit.
        </p>
      </div>
      
      <h5>A brief history lesson</h5>
      <p className="">
        The PAT file goes back, way back. It was first released in October of 1983 for AutoCAD Version 1.4, the 4th version of AutoCAD - ever (<a href="https://autodesk.blogs.com/between_the_lines/ACAD_R4.html" target="_blank" rel="noreferrer">reference</a>). Since then, the official .PAT file syntax has been updated and its currently in its third version. This version is compatible with both AutoCAD, Revit, and the majority of other CAD programs. Pattycake is designed to work specifically with this version. 
      </p>
      <p className="p-push-down">
        It’s hard to read the history of the .PAT file development without developing a bit of respect. A language developed 36 years ago has only been updated twice and is still routinely being used in some of the biggest architecture and construction projects of the day. What first can seem like a confusing and restricted language to create lines and dashes, becomes a sophisticatedly simple language that guarantees its flexibility for future use.
      </p>
    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/what-is-a-pat-file.js